import React, { useState, useEffect } from 'react';
import { Box, Input, Button, Text, FormControl, FormLabel, VStack } from '@chakra-ui/react';
import { useNavigate, useParams } from 'react-router-dom';
import Navbar from '../../elements/Navbar/Navbar';
import { createDocument, getRequest, hadlePreFilledFields } from '../../ServiceRequest';


const NewDocument: React.FC = () => {
    const navigate = useNavigate();

    const [newDocumentData, setNewDocumentData] = useState<any>({})
    const [template, setTemplate] = useState<any>({})
    const [project, setProject] = useState<any>({})

    const { project_id, template_name } = useParams<{
        project_id: any;
        template_name: any;
    }>();

    const handleGetProject = async (project_id: any) => {
        await hadlePreFilledFields(project_id)
            .then(response => setProject(response))
    }

    const handleNewDocumentData = (e: any) => {
        const { name, value } = e.target;
        setNewDocumentData({
            ...newDocumentData,
            [name]: value
        });
    }

    const handleTemplate = async (template_name: any) => {
        await getRequest(`templates/${template_name}`)
            .then(response => setTemplate(response))
    }

    const handleCreateNewDocument = async (e: any) => {
        if (newDocumentData) {
            const newDocument = await createDocument(newDocumentData.name, newDocumentData.description, template_name, project_id);

            navigate(`/${newDocument.data.projectId}/${newDocument.data._id}/${newDocument.data.templateName}`)
        }

    }

    useEffect(() => {
            handleTemplate(template_name);
    }, [])

    useEffect(() => {
        handleGetProject(project_id);
    }, [project_id])

    if (!project) {
        return (
            <>
                <Box className="container" textAlign="center" p={5}>
                    <Navbar />
                    <Box className="form-container">
                        <Box className="form">
                            <Box as="form">

                                <VStack spacing={4} align="stretch">
                                    <Text className="title" fontSize="2xl" my={10}>Invalid Project ID</Text>
                                </VStack>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </>
        )
    }

    if (!template) {
        return (
            <>
                <Box className="container" textAlign="center" p={5}>
                    <Navbar />
                    <Box className="form-container">
                        <Box className="form">
                            <Box as="form">

                                <VStack spacing={4} align="stretch">
                                    <Text className="title" fontSize="2xl" my={10}>Invalid Template Name</Text>
                                </VStack>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </>
        )
    }

    return (
        <Box className="container" textAlign="center" p={5}>
            <Navbar />
            <Box className="form-container">
                <Box className="form">
                    <Box as="form">
                        <Text className="title" fontSize="2xl" mb={6}>Create new Work Order Document</Text>
                        <VStack spacing={4} align="stretch">
                            <FormControl className="input-field" mb={4}>
                                <FormLabel>Project ID</FormLabel>
                                <Input value={project_id ? project_id : ''} readOnly={true} />
                            </FormControl>
                            <FormControl className="input-field" mb={4}>
                                <FormLabel>Template</FormLabel>
                                <Input value={template.alias ? template.alias : ''} readOnly={true} />
                            </FormControl>
                            <FormControl className="input-field" mb={4}>
                                <FormLabel>Document name</FormLabel>
                                <Input name="name" placeholder="Enter a name for this document" onChange={handleNewDocumentData} />
                            </FormControl>
                            <FormControl className="input-field" mb={4}>
                                <FormLabel>Document description</FormLabel>
                                <Input name="description" placeholder="Enter a description" onChange={handleNewDocumentData} />
                            </FormControl>

                            <Button className='button' colorScheme="#333" mt={5} onClick={handleCreateNewDocument}>Create document</Button>
                        </VStack>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default NewDocument;